import { render, staticRenderFns } from "./NewsSlider.vue?vue&type=template&id=05036324&scoped=true"
import script from "./NewsSlider.vue?vue&type=script&lang=js"
export * from "./NewsSlider.vue?vue&type=script&lang=js"
import style0 from "./NewsSlider.vue?vue&type=style&index=0&id=05036324&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05036324",
  null
  
)

export default component.exports